import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("rc_token");
  if (token) cfg.headers["Authorization"] = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Don't clobber from the login attempts themselves
      const url = err.config?.url || "";
      if (!url.includes("/auth/")) {
        localStorage.removeItem("rc_token");
        localStorage.removeItem("rc_user");
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export const fmtINR = (n) => {
  if (n == null || isNaN(n)) return "₹0";
  const v = Number(n);
  return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

// Compact Indian-style format for mobile: ₹1.57 Cr, ₹85 L, ₹12 K
export const fmtINRcompact = (n) => {
  if (n == null || isNaN(n)) return "₹0";
  const v = Math.abs(Number(n));
  const sign = Number(n) < 0 ? "-" : "";
  if (v >= 1e7) return `${sign}₹${(v / 1e7).toFixed(v >= 1e8 ? 0 : 2)} Cr`;
  if (v >= 1e5) return `${sign}₹${(v / 1e5).toFixed(v >= 1e6 ? 0 : 1)} L`;
  if (v >= 1e3) return `${sign}₹${(v / 1e3).toFixed(0)} K`;
  return `${sign}₹${v.toFixed(0)}`;
};

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return d; }
};

export const relativeTime = (d) => {
  if (!d) return "";
  const t = new Date(d).getTime();
  if (Number.isNaN(t)) return "";
  const diff = (Date.now() - t) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(d);
};
